import { render, staticRenderFns } from "./VersionAddOrUpdate.vue?vue&type=template&id=9f6992c8&"
import script from "./VersionAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./VersionAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports